import React from 'react';
import Navbar from "../parts/Navbar";
import Sidebar from "../parts/Sidebar";
import ControlSidebar from "../parts/ControlSidebar";
import Footer from "../parts/Footer";
import ReportCompanies from "../parts/ReportCompanies";

const ReportCompaniesPage = () => {
    return (
        <div className="wrapper">
            <Navbar/>
            <Sidebar/>
            <ControlSidebar/>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1 className="m-0" style={{wordBreak: 'break-word'}}>Rapoarte · Companii</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <ReportCompanies/>
                    </div>
                </section>
                {/* footer-ul AdminLTE e position:fixed -> spacer ca sa nu acopere finalul */}
                <div style={{height: 60}}/>
            </div>
            <Footer/>
        </div>
    );
};

export default ReportCompaniesPage;
